<template>
  <div class="work-schedule-item" :class="{'is-transfer': isTransfer}">
    <div class="schedule-line">
      <div class="schedule-user">
        <div class="d-flex align-center">
          <div class="avatars d-flex flex-column">
            <avatar :user="selectedUser"/>
          </div>
          <div>
            <div class="select-section">
              <v-select
                v-model="selectedUserId"
                :items="usersList"
                item-text="name"
                item-value="id"
                hide-details="auto"
                item-color="#ff9100"
                class="select"
                solo
                height="42"
                clearable
                :disabled="isReadonly || isTransfer"
                @change="changeUserId"
                flat
              />
            </div>
          </div>
        </div>
      </div>
      <div class="schedule-transfer">
        <div class="transfer d-sm-flex align-center">
          <template v-if="workSpace.isCallCenter">
            <div class="call-center-label d-flex align-center">
              <img src="/img/stat/icons/headset-solid.svg" class="call-center-label_icon"/>
              <div class="call-center-label_number">
                {{ workSpaceNumber }}
              </div>
              <div class="call-center-label_desc">
                Рабочее место
              </div>
            </div>
          </template>

          <template v-else-if="canStartTransfer">
            <orange-checkbox
              label="Отправить на другой филиал"
              off-label-color="#C4CDD9"
              v-model="startTransfer"
            />
            <div class="d-flex align-center pt-sm-2">
              <div class="select-section">
                <v-select
                  v-if="startTransfer"
                  v-model="transferToFilialId"
                  :items="transferFilialsList"
                  item-text="name"
                  item-value="id"
                  hide-details="auto"
                  item-color="#ff9100"
                  class="select transfer-filial-select"
                  solo
                  height="42"
                  flat
                />
              </div>

              <user-transfer-confirm-dialog
                v-if="startTransfer && transferToFilialId"
                :user="selectedUser"
                :to-filial="transferToFilial"
                :work-schedule-id="workScheduleId"
                :work-space-id="workSpace.id"
                @cancel="startTransfer=false"
              />
            </div>
          </template>

          <template v-else-if="isTransfer">
            <div class="d-flex align-center">
              <v-btn
                v-if="isTransferWait"
                class="transfer-wait-btn"
                dark
                color="#ff9100"
                height="40"
                :disabled="loadingCompleteRequest"
                :loading="loadingCompleteRequest"
                @click="completeTransfer"
              >
                ПРИБЫЛ НА ФИЛИАЛ
              </v-btn>
              <div class="transfer-filials" :class="{'d-flex': isTransferred || isTransferArrived}">
                <div>{{ transferFromFilialName }} <span><font-awesome-icon icon="arrow-right" /></span></div>
                <div>{{ transferToFilialName }}</div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="schedule-times">
        <v-row class="times">
          <v-col cols="6" class="times-col">
            <label>Начало смены</label>
            <vue-timepicker
              class="time-inp"
              v-model="begin"
              :minute-interval="5"
              :disabled="!selectedUserId || isReadonly || isTransfer"
              @change="changeBeginTime"
              :input-class="{'has-error': !beginValid}"
              format="HH:mm"
              placeholder="__:__"
              hide-clear-button
              auto-scroll
              drop-direction="auto"
              input-width="100%"
              hide-disabled-hours
              manual-input
              :manual-input-timeout="1000"
              lazy
            ></vue-timepicker>
            <!--            :hour-range="[[minTime.hours(), maxTime.hours()]]"-->
          </v-col>

          <v-col cols="6" class="times-col">
            <label>Конец смены</label>
            <vue-timepicker
              class="time-inp"
              v-model="end"
              :minute-interval="5"
              :disabled="!selectedUserId || isReadonly"
              @change="changeEndTime"
              :input-class="{'has-error': !endValid}"
              format="HH:mm"
              placeholder="__:__"
              hide-clear-button
              auto-scroll
              drop-direction="auto"
              input-width="100%"
              hide-disabled-hours
              manual-input
              :manual-input-timeout="1000"
              lazy
            ></vue-timepicker>
            <!--            :hour-range="[[minTime.hours(), maxTime.hours()]]"-->
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import moment from 'moment'

  import Avatar from '@/components/administrator/work-shift/staff/Avatar'
  import OrangeCheckbox from '@/components/ui/castom-inputs/OrangeCheckbox'
  import WorkScheduleTransferStatus from '@/models/enums/WorkScheduleTransferStatus'
  import VueTimepicker from 'vue2-timepicker'
  import 'vue2-timepicker/dist/VueTimepicker.css'
  import '@/styles/VueTimepickerTheme.scss'

  import { WORK_DAY_START, WORK_DAY_END } from '@/util/globals'
  import UserTransferConfirmDialog from '@/components/administrator/work-shift/staff/UserTransferConfirmDialog'
  import SnackbarMessage from '@/mixins/snackbar-message'

  export default {
    name: 'WorkScheduleItem',
    components: { UserTransferConfirmDialog, Avatar, OrangeCheckbox, VueTimepicker },
    mixins: [SnackbarMessage],
    props: {
      users: {
        type: Array,
        default: () => ([]),
      },
      workSchedule: {
        type: Object,
        default: () => ({}),
      },
      workSpace: {
        type: Object,
        default: () => ({}),
      },
      readonly: {
        type: Boolean,
        default: false,
      },
    },

    data () {
      return {
        minTime: moment(WORK_DAY_START, 'HH:mm'),
        maxTime: moment(WORK_DAY_END, 'HH:mm'),

        selectedUserId: null,
        begin: null,
        end: null,

        // beginValid: true,
        // endValid: true,

        // Start transfer
        startTransfer: false,
        transferToFilialId: 0,
        showTransferConfirm: false,
        loadingCompleteRequest: false,
      }
    },
    watch: {
      workSchedule (newValue) {
        this.selectedUserId = newValue.userId
        this.begin = newValue.begin ?? ''
        this.end = newValue.end ?? ''
      },
    },

    computed: {
      ...mapGetters({
        selectedDate: 'orders/getSelectedDate',
        selectedFilial: 'branches/getGlobalFilialId',
        modifiedWorkSchedules: 'dayWorkSchedule/getModifiedWorkSchedules',
        allFilials: 'branches/getBranches',
        globalFilialName: 'branches/getGlobalFilialName',
      }),
      usersList () {
        if (this.workSchedule.isTransfer && this.workSchedule.user) {
          return this.users.concat(this.workSchedule.user)
        }
        return this.users
      },
      selectedUser () {
        return this.usersList.find((item) => item.id === this.selectedUserId)
      },
      transferFilialsList () {
        return this.allFilials.filter((filial) => filial.id !== this.selectedFilial)
      },
      transferToFilial () {
        return this.transferFilialsList.find((filial) => filial.id === this.transferToFilialId)
      },
      isReadonly () {
        return /* this.workSchedule.isTransfer || */ this.readonly
      },
      hasError () {
        return !this.beginValid || !this.endValid
      },
      workScheduleId () {
        return this.workSchedule.id ?? null
      },
      workSpaceNumber () {
        const number = this.workSpace.number
        return number < 10 ? `0${number}` : number
      },
      itemKey () {
        return `${this.workSpace.id}-${this.workScheduleId}`
      },
      isNewWorkSchedule () {
        return !this.workSchedule.id
      },
      isTransfer () {
        return this.workSchedule.userId && this.workSchedule.isTransfer
      },
      canStartTransfer () {
        return this.selectedUserId && !this.isTransfer
      },
      isTransferred () {
        return this.workSchedule.userId &&
          this.isTransfer &&
          this.workSchedule.transferStatus === WorkScheduleTransferStatus.Transferred
      },
      isTransferWait () {
        return this.workSchedule.userId &&
          this.isTransfer &&
          this.workSchedule.transferStatus === WorkScheduleTransferStatus.Wait
      },
      isTransferArrived () {
        return this.workSchedule.userId &&
          this.isTransfer &&
          this.workSchedule.transferStatus === WorkScheduleTransferStatus.Arrived
      },
      transferToFilialName () {
        return this.workSchedule?.transferToFilial?.name
      },
      transferFromFilialName () {
        return this.workSchedule?.transferFromFilial?.name
      },

      beginValid () {
        if (!this.begin) {
          // Пустое время допустимо только без сотрудника (снятие со смены):
          // смена без времени не попадает в nowAtWork(), и курьеры не видят админа
          return !this.selectedUserId
        }
        const time = moment(this.begin, 'HH:mm')
        if (time.isValid() /* && time.isBetween(this.minTime, this.maxTime, 'minute', '[)') */) {
          return this.validateTimeInterval()
        }
        return false
      },

      endValid () {
        if (!this.end) {
          return !this.selectedUserId
        }
        const time = moment(this.end, 'HH:mm')
        if (time.isValid() /* && time.isBetween(this.minTime, this.maxTime, 'minute', '(]') */) {
          return this.validateTimeInterval()
        }
        return false
      },
    },

    mounted () {
      this.selectedUserId = this.workSchedule.userId
      this.begin = this.workSchedule.begin ?? ''
      this.end = this.workSchedule.end ?? ''
    },

    methods: {
      addItemToModified () {
        console.log('add item')
        const data = {
          isTransfer: this.isTransfer,
          workScheduleId: this.workScheduleId,
          workSpaceId: this.workSpace.id,
          key: this.itemKey,
          userId: this.selectedUserId || null,
          begin: this.begin,
          end: this.end,
          hasError: this.hasError,
        }

        this.$store.commit('dayWorkSchedule/addModifiedWorkSchedule', data)
      },

      changeEndTime () {
        // const time = moment(this.end, 'HH:mm')
        // this.endValid = time.isValid() && time.isBetween(this.minTime, this.maxTime, 'minute', '(]')

        this.addItemToModified()
      },

      changeBeginTime () {
        // const time = moment(this.begin, 'HH:mm')
        // this.beginValid = time.isValid() && time.isBetween(this.minTime, this.maxTime, 'minute', '[)')

        this.addItemToModified()
      },

      changeUserId () {
        if (this.isNewWorkSchedule && this.selectedUserId > 0) {
          if (!this.begin) {
            this.begin = this.minTime.format('HH:mm')
          }
          if (!this.end) {
            this.end = this.maxTime.format('HH:mm')
          }
        }
        // При очистке сотрудника время не сбрасываем: vue2-timepicker не очищает поле
        // по пустому v-model, и данные расходились с экраном - при выборе другого
        // сотрудника в тот же слот уходило пустое время
        this.addItemToModified()
      },

      validateTimeInterval () {
        if (this.begin && this.end) {
          const begin = moment(this.begin, 'HH:mm')
          const end = moment(this.end, 'HH:mm')
          if (begin.isAfter(end)) {
            // return false
          }
        }
        return true
      },
      completeTransfer () {
        this.loadingCompleteRequest = true

        this.$store
          .dispatch('dayWorkSchedule/completeWorkScheduleTransfer', {
            id: this.workSchedule.id,
          })
          .catch((err) => this.showErrorFromResponse(err))
          .finally(() => {
            this.loadingCompleteRequest = false
          })
      },
    },
  }
</script>

<style lang="less" scoped>
.work-schedule-item {
  padding: 0 12px;
  background: #F1F3F6;
  border-radius: 4px;
  margin-bottom: 10px;

  @media (max-width: @sm) {
    flex-wrap: wrap;
    margin-bottom: 30px;
  }
  .schedule-line {
    display: flex;
    justify-content: stretch;
    width: 100%;
    align-items: center;

    .schedule-user {
      flex-grow: 1;
      flex-basis: 400px;
      max-width: 340px;

      .select-section {
        max-width: 266px;
      }
    }
    .schedule-transfer {
      flex-grow: 1;
      padding: 0 20px;

      .transfer {

      }

      .transfer-filials {
        color: #fff;
        margin-left: 30px;

        span {
          color: #FB8C00;
          padding: 0 10px;
        }
      }
    }

    .call-center-label {
      &_icon {
        max-height: 22px;
      }

      &_number {
        font-size: 22px;
        margin-left: 10px;
      }

      &_desc {
        font-size: 12px;
        margin-left: 10px;
      }
    }

    .schedule-times {
      flex-grow: 1;
      flex-basis: 210px;
      max-width: 210px;
      width: 210px;
    }

  }

  .select-section {
    //flex: 1 1 auto;
    display: flex;
    align-items: center;

    .select {
      //margin-bottom: 12px;
    }

    ::v-deep {
      .v-input {
        font-size: 14px;
      }

      .v-text-field.v-text-field--solo {
        .v-input__control {
          min-height: 42px;
        }

        .v-input__slot {
          height: 42px;
          min-height: 42px;
        }
      }
      .theme--light.v-select .v-select__selection--disabled {
        color: #414141 !important;
        cursor: not-allowed;
      }

    }
  }

  .transfer-filial-select {
    margin-left: 20px;
    width: 180px;
  }

  .times {
    .times-col {
      text-align: center;
      position: relative;

      &:first-child{
        padding-right: 20px;
        &:after {
          content: '';
          display: block;
          position: absolute;
          right: 0;
          top: 12px;
          bottom: 12px;
          width: 1px;
          background: #C4CDD9;
        }
      }

      &:last-child {
        padding-left: 20px;
      }
    }

    label {
      font-size: 12px;
      margin-bottom: 5px;
      line-height: 1;
      margin-top: -3px;
      display: block;
      white-space: nowrap;
    }

    .time-inp {
      ::v-deep {
        input {
          height: 35px;
          background: #fff;
          outline: none;
          border-radius: 4px;
          padding: 4px;
          text-align: center;
          font-size: 14px;
          border: 1px solid transparent;

          &.has-error {
            border-color: red !important;
          }

          &:disabled {
            color: #414141 !important;
          }
        }
      }
    }

  }

  .staff-radio {
    display: flex;
    align-items: center;
    margin-left: 24px;

    ::v-deep {
      .v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
        margin-bottom: 0 !important;
      }

      .v-input--radio-group--column .v-input--radio-group__input {
        display: flex !important;
        flex-direction: row !important;
        align-items: center;
      }
    }
  }

  .avatars {
    .avatar {
      width: 50px;
      height: 50px;
      border: 4px solid #fff;
      background-color: #00000008;
      border-radius: 50%;
      margin-right: 24px;
      flex-shrink: 0;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #cfcfcf;

      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }

      &:nth-child(2) {
        margin-top: 10px;
      }
    }
  }

  .select {
    .v-input__slot {
      height: 60px;
    }
  }

  &.is-transfer {
    background-color: #040404;

    .times {
      label {
        color: #fff;
      }
    }
  }

  .media-sm({
    padding-top: 12px;

    .schedule-line {
      display: block;

      .schedule-user {
        max-width: 100%;
        width: 100%;
        margin-bottom: 17px;
      }

      .schedule-transfer {
        margin-bottom: 12px;
        padding: 0;

        .checkbox {
          margin-bottom: 12px;
        }

        .transfer-filial-select {
          margin-left: 0;
        }
      }

      .schedule-times {
        width: 100%;
        max-width: 100%;
      }
    }
  })
}
</style>
